import { defineMessages } from "react-intl";

const messages = defineMessages({
  tradingLimit: {
    id: "fractionalTrading.utils.tradingLimit",
    defaultMessage: "Trading Limit",
  },
  configurationSymbols: {
    id: "fractionalTrading.utils.configurationSymbols",
    defaultMessage: "Configuration Symbols",
  },
  restrictedConfiguration: {
    id: "fractionalTrading.utils.restrictedConfiguration",
    defaultMessage: "Restricted Configuration",
  },
});

export default messages;
